var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['icon', _vm.extraClass, _vm.iconClass],style:(_vm.extraStyle),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},on:{"click":function($event){return _vm.$emit('handle-click')}}},[_c('use',{attrs:{"href":`${require('@/assets/symbol-defs.svg')}#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }